import React, { createContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAPI } from 'hooks';
import PropTypes from 'prop-types';

export const PermissionsContext = createContext({});

const PermissionsProvider = ({ children }) => {
  const { api } = useAPI();

  const { data: permissionsArray } = useQuery({
    queryFn: api.retrieve('permission', 'current/'),
    queryKey: ['permission/current/'],
    retry: false, // disable retries on failure
  });

  const permissions = permissionsArray?.data[0] || {};

  const isManualLocked = permissions?.platform_locked;

  const isRegistrationEnd = permissions?.campaign_registration_end || false;

  const isQuotaReached = permissions?.quota_reached || false;

  const isPlatformLocked = isManualLocked ?? (isRegistrationEnd || isQuotaReached);

  const value = useMemo(
    () => ({
      permissions,
      isPlatformLocked,
      isManualLocked,
      isRegistrationEnd,
      isQuotaReached,
    }),
    [permissions]
  );

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};

PermissionsProvider.propTypes = {
  children: PropTypes.node,
};

export default PermissionsProvider;
